<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">回報問題列表</h1>
        <p class="page-subtitle">管理學生反饋的題目問題，跟蹤處理狀態</p>
      </div>
      <div class="header-right">
        <el-button type="default" @click="onReset" icon="el-icon-refresh">
          重置篩選
        </el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 筛选搜索区 -->
      <div class="search-card">
        <!-- PC端筛选栏（≥768px显示） -->
        <div class="pc-search">
          <div class="search-row">
            <div class="search-item">
              <div class="search-text">回報日期和時間</div>
              <el-date-picker
                  v-model="formLabelAlign.createdAt"
                  type="date"
                  placeholder="請輸入回報日期和時間"
                  value-format="yyyy-MM-dd"
                  size="small"
                  style="width: 100%;"
              >
              </el-date-picker>
            </div>
            <div class="search-item">
              <div class="search-text">回報人</div>
              <el-input
                  v-model="formLabelAlign.studentNameLike"
                  placeholder="請輸入回報人"
                  size="small"
                  style="width: 100%;"
              ></el-input>
            </div>
            <div class="search-item">
              <div class="search-text">題目編號</div>
              <el-input
                  v-model="formLabelAlign.questionNoLike"
                  placeholder="請輸入題目編號"
                  size="small"
                  style="width: 100%;"
              ></el-input>
            </div>
            <div class="search-item">
              <div class="search-text">題目類型</div>
              <el-select
                  v-model="formLabelAlign.questionDisplayType"
                  clearable
                  placeholder="全部"
                  size="small"
                  style="width: 100%;"
              >
                <el-option
                    v-for="(item, index) in questionTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="search-item">
              <div class="search-text">狀態</div>
              <el-select
                  v-model="formLabelAlign.state"
                  clearable
                  placeholder="全部"
                  size="small"
                  style="width: 100%;"
              >
                <el-option label="待處理" value="0"></el-option>
                <el-option label="已處理" value="1"></el-option>
              </el-select>
            </div>
            <div class="search-item search-button">
              <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">
                搜尋
              </el-button>
            </div>
          </div>
        </div>

        <!-- 移动端筛选栏（<768px显示） -->
        <div class="mobile-search">
          <el-collapse>
            <el-collapse-item title="篩選條件" name="1">
              <div class="mobile-search-form">
                <el-form size="small" label-width="80px">
                  <el-form-item label="回報日期">
                    <el-date-picker
                        v-model="formLabelAlign.createdAt"
                        type="date"
                        placeholder="請選擇日期"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="回報人">
                    <el-input
                        v-model="formLabelAlign.studentNameLike"
                        placeholder="請輸入回報人"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="題目編號">
                    <el-input
                        v-model="formLabelAlign.questionNoLike"
                        placeholder="請輸入題目編號"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="題目類型">
                    <el-select
                        v-model="formLabelAlign.questionDisplayType"
                        clearable
                        placeholder="全部"
                        style="width: 100%;"
                    >
                      <el-option
                          v-for="(item, index) in questionTypes"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="處理狀態">
                    <el-select
                        v-model="formLabelAlign.state"
                        clearable
                        placeholder="全部"
                        style="width: 100%;"
                    >
                      <el-option label="待處理" value="0"></el-option>
                      <el-option label="已處理" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <div class="mobile-search-buttons">
                      <el-button type="warning" @click="onSearch" icon="el-icon-search" style="width: 48%;">
                        搜尋
                      </el-button>
                      <el-button @click="onReset" icon="el-icon-refresh" style="width: 48%;">
                        重置
                      </el-button>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <!-- 数据展示区 -->
      <div class="data-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="newTableData"
              style="width: 100%;"
              border
              stripe
              size="small"
              :empty-text="newTableData.length === 0 ? '暫無回報問題數據' : ''"
          >
            <el-table-column label="#" type="index" width="60"> </el-table-column>
            <el-table-column
                prop="createdAt"
                label="回報日期和時間"
                align="center"
                min-width="180"
            >
              <template slot-scope="{ row }">
                <span>{{ row.createdAt | formatDateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="user.name"
                label="回報人"
                align="center"
                min-width="100"
            >
              <template slot-scope="{ row }">
                <span v-if="row.user" class="username">{{ row.user.userNo }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="question.questionNo"
                label="題目編號"
                align="center"
                min-width="120"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <span v-if="row.question" class="question-no">{{ row.question.questionNo }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="question.type"
                label="題目類型"
                align="center"
                min-width="120"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <el-tag size="mini" v-if="row.question" type="info">
                  {{ row.question.type | questions }}
                </el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="user.grade.name"
                label="年级"
                align="center"
                min-width="80"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <span v-if="row.user && row.user.grade && row.user.grade.name">{{ row.user.grade.name }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="state"
                label="狀態"
                align="center"
                min-width="100"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <el-tag
                    :type="row.state===1 ? 'success' : 'warning'"
                    size="mini"
                >
                  {{ row.state===0?'待處理':'已處理'}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="{ row }">
                <el-button
                    type="text"
                    size="small"
                    @click="onDetailButton(row.id)"
                    icon="el-icon-view"
                >
                  詳情
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    @click="onUpdateState(row.id,1)"
                    icon="el-icon-check"
                    :disabled="row.state === 1"
                    :style="row.state === 1 ? 'color: #999;' : 'color: #166ea5;'"
                >
                  處理
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="feedback-card" v-for="(row, index) in newTableData" :key="row.id || index">
            <!-- 卡片头部：状态 + 日期 -->
            <div class="card-header">
              <el-tag
                  :type="row.state===1 ? 'success' : 'warning'"
                  size="mini"
                  class="state-tag"
              >
                {{ row.state===0?'待處理':'已處理'}}
              </el-tag>
              <div class="feedback-date">{{ row.createdAt | formatDateTime }}</div>
            </div>

            <!-- 卡片主体 -->
            <div class="card-body">
              <div class="info-item">
                <span class="label">回報人：</span>
                <span class="value">{{ row.user?.userNo || '未知' }}</span>
              </div>
              <div class="info-item">
                <span class="label">年級：</span>
                <span class="value">{{ row.user?.grade?.name || '未知' }}</span>
              </div>
              <div class="info-item">
                <span class="label">題目編號：</span>
                <span class="value question-no">{{ row.question?.questionNo || '未知' }}</span>
              </div>
              <div class="info-item">
                <span class="label">題目類型：</span>
                <el-tag size="mini" type="info" v-if="row.question">
                  {{ row.question.type | questions }}
                </el-tag>
                <span v-else class="value">未知</span>
              </div>
            </div>

            <!-- 卡片操作栏 -->
            <div class="card-actions">
              <el-button
                  type="text"
                  size="mini"
                  @click="onDetailButton(row.id)"
                  icon="el-icon-view"
                  class="detail-btn"
              >
                查看詳情
              </el-button>
              <el-button
                  type="warning"
                  size="mini"
                  @click="onUpdateState(row.id,1)"
                  icon="el-icon-check"
                  :disabled="row.state === 1"
                  class="handle-btn"
              >
                標記為已處理
              </el-button>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="newTableData.length === 0">
            <i class="el-icon-message-solid"></i>
            <p>暫無回報問題數據</p>
          </div>
        </div>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container" v-show="total > 0">
        <Pagination
            :total="total"
            :page.sync="formLabelAlign._page"
            :limit.sync="formLabelAlign._limit"
            @pagination="getQuestionFeedbacks"
        />
      </div>
    </div>

    <!-- 确认对话框 -->
    <deleteDialog
        titleCh="您確定要將此訂單價格更改為0嗎? <br />該訂單狀態將改為已支付"
        :centerDialogVisible="centerDialogVisible"
        @confirmFunction="confirmFunction"
        @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getQuestionFeedbacks, updateState } from "@/api/setting";
import deleteDialog from "@/components/deleteDialog";

export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      sortingType: '',
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      questionTypes: [
        { label: "全部", value: null },
        { label: "選擇題", value: 0 },
        { label: "判斷題", value: 1 },
        { label: "填空題", value: 2 },
        { label: "算術題(定數)", value: 3 },
        { label: "熱點圖", value: 4 },
        { label: "文字拖拽", value: 5 },
        { label: "連線題", value: 6 },
        { label: "拖拽題", value: 7 },
        { label: "算術題(變數)", value: 8 },
        { label: "文字拖拽(分類)", value: 9 },
      ],
      formLabelAlign: {
        studentNameLike: null,
        orderNoLike: null,
        createdAt: null,
        userNo: null,
        status: null,
        state: null,
        questionDisplayType: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getQuestionFeedbacks();
  },
  computed: {
    newTableData() {
      return this.tableData;
    }
  },
  methods: {
    // 路由跳转方法补充
    resolveRouter(path) {
      this.$router.push(path);
    },
    // 排序处理
    handleSortChange(column) {
      const fieldName = column.prop;
      this.sortingType = column.order;
      const fieldNameList = fieldName.split('.');

      if (!this.newTableData.length) return;

      if (this.sortingType == 'ascending') {
        // 正序
        if (fieldNameList.length == 3) {
          this.newTableData.sort((a, b) => {
            const valA = a[fieldNameList[0]]?.[fieldNameList[1]]?.[fieldNameList[2]] || '';
            const valB = b[fieldNameList[0]]?.[fieldNameList[1]]?.[fieldNameList[2]] || '';
            return valA.toString().localeCompare(valB.toString(), 'zh-CN');
          });
        } else {
          this.newTableData.sort((a, b) => {
            const valA = a[fieldNameList[0]]?.[fieldNameList[1]] || '';
            const valB = b[fieldNameList[0]]?.[fieldNameList[1]] || '';
            return valA.toString().localeCompare(valB.toString(), 'zh-CN');
          });
        }
      } else if (this.sortingType == 'descending') {
        // 倒序
        if (fieldNameList.length == 3) {
          this.newTableData.sort((a, b) => {
            const valA = a[fieldNameList[0]]?.[fieldNameList[1]]?.[fieldNameList[2]] || '';
            const valB = b[fieldNameList[0]]?.[fieldNameList[1]]?.[fieldNameList[2]] || '';
            return valB.toString().localeCompare(valA.toString(), 'zh-CN');
          });
        } else {
          this.newTableData.sort((a, b) => {
            const valA = a[fieldNameList[0]]?.[fieldNameList[1]] || '';
            const valB = b[fieldNameList[0]]?.[fieldNameList[1]] || '';
            return valB.toString().localeCompare(valA.toString(), 'zh-CN');
          });
        }
      }
    },
    // 用户编号点击
    onUserNoText(id) {
      this.$router.push({ path: `/user/${id}` });
    },
    // 重置筛选
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if (key == '_page') {
          this.formLabelAlign[key] = 1;
        }
        if (key == '_limit') {
          this.formLabelAlign[key] = 10; // 恢复默认10条/页
        }
      });
      this.getQuestionFeedbacks();
      this.$message.info("篩選條件已重置");
    },
    // 搜索
    onSearch() {
      this.formLabelAlign._page = 1; // 搜索时重置页码
      this.getQuestionFeedbacks();
    },
    // 取消对话框
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    // 确认操作
    confirmFunction() {
      this.centerDialogVisible = false;
    },
    // 编辑
    onEditButton(id) {
      this.$router.push({ path: `/returnProblem/${id}/edit` });
    },
    // 查看详情
    onDetailButton(id) {
      let path = `/returnProblem/${id}`;
      this.resolveRouter(path);
    },
    // 更新状态
    onUpdateState(id, state) {
      let formLabelAlign = {
        id: id,
        state: state
      };

      // 加载中提示
      const loading = this.$loading({
        lock: true,
        text: '處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      updateState(formLabelAlign)
          .then(() => {
            this.$message.success("狀態更新成功");
            this.getQuestionFeedbacks();
          })
          .catch(err => {
            this.$message.error("狀態更新失敗，請稍後重試");
            console.error('更新状态失败：', err);
          })
          .finally(() => {
            loading.close();
          });
    },
    // 修改按钮
    onAlterButton(id) {
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    // 获取问题反馈列表
    getQuestionFeedbacks() {
      let formLabelAlign = {
        createdAt: this.formLabelAlign.createdAt,
        studentNameLike: this.formLabelAlign.studentNameLike,
        questionNoLike: this.formLabelAlign.questionNoLike,
        state: this.formLabelAlign.state,
        questionDisplayType: this.formLabelAlign.questionDisplayType,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };

      // 加载中提示
      const loading = this.$loading({
        lock: true,
        text: '加載數據中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      getQuestionFeedbacks(formLabelAlign)
          .then((v) => {
            this.tableData = v.data || [];
            this.total = Number(v.headers["x-total-count"]) || 0;
          })
          .catch(err => {
            this.$message.error("獲取回報問題列表失敗，請稍後重試");
            console.error('获取数据失败：', err);
            this.tableData = [];
            this.total = 0;
          })
          .finally(() => {
            loading.close();
          });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 搜索卡片样式 */
.search-card {
  margin-bottom: 20px;

  /* PC端搜索样式 */
  .pc-search {
    .search-row {
      display: grid;
      grid-template-columns: repeat(5, 1fr) auto;
      gap: 12px;
      padding: 16px;
      background: #f8f9fa;
      border-radius: 6px;

      .search-item {
        .search-text {
          margin-bottom: 4px;
          font-size: 12px;
          color: #6c757d;
          font-weight: 500;
        }
      }

      .search-button {
        display: flex;
        align-items: flex-end;

        .el-button {
          width: 100%;
        }
      }
    }
  }

  /* 移动端搜索样式 */
  .mobile-search {
    display: none;

    .mobile-search-form {
      padding: 16px 8px;
    }

    .mobile-search-buttons {
      display: flex;
      justify-content: space-between;
      gap: 8px;
    }
  }
}

/* 数据容器样式 */
.data-container {
  width: 100%;
  margin-bottom: 20px;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep {
      .el-table {
        --el-table-header-text-color: #4e5969;
        --el-table-row-hover-bg-color: #f8f9fa;
      }

      .el-table th {
        background: #f8f9fa;
        font-weight: 600;
      }

      .username {
        font-weight: 500;
      }

      .question-no {
        font-weight: 600;
        color: #166ea5;
      }
    }
  }

  /* 手机端卡片样式 */
  .mobile-cards {
    display: none;
    flex-direction: column;
    gap: 16px;

    /* 反馈卡片 */
    .feedback-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e9ecef;
      transition: all 0.2s ease;

      &:hover {
        border-color: #166ea5;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }

      /* 卡片头部 */
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dee2e6;

        .feedback-date {
          font-size: 12px;
          color: #6c757d;
        }
      }

      /* 卡片主体 */
      .card-body {
        margin-bottom: 16px;

        .info-item {
          display: flex;
          margin-bottom: 8px;
          line-height: 1.4;

          .label {
            font-size: 12px;
            color: #6c757d;
            min-width: 60px;
            flex-shrink: 0;
          }

          .value {
            font-size: 14px;
            color: #1f2937;
            flex: 1;
          }

          .question-no {
            font-weight: 600;
            color: #166ea5;
          }
        }
      }

      /* 卡片操作栏 */
      .card-actions {
        display: flex;
        gap: 8px;
        padding-top: 12px;
        border-top: 1px solid #f1f3f5;

        .el-button {
          flex: 1;
          text-align: center;
        }

        .detail-btn {
          color: #409eff;
        }

        .handle-btn {
          &:disabled {
            background-color: #e9ecef;
            border-color: #e9ecef;
            color: #999;
          }
        }
      }
    }

    /* 空数据提示 */
    .empty-tip {
      text-align: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
        color: #ced4da;
      }

      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }
}

/* 分页容器 */
.pagination-container {
  text-align: right;
  padding: 10px 0;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .layout {
    //padding: 16px;
  }

  /* 隐藏PC搜索，显示移动端搜索 */
  .search-card .pc-search {
    display: none;
  }
  .search-card .mobile-search {
    display: block;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .data-container .pc-table {
    display: none;
  }
  .data-container .mobile-cards {
    display: flex;
  }

  /* 分页适配 */
  .pagination-container {
    text-align: center;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .layout {
    //padding: 20px;
  }

  .search-card .search-row {
    grid-template-columns: repeat(3, 1fr) auto;
  }
}
</style>